//*react- recursos
import React, { useState, useCallback } from "react";
import { useDropzone } from "react-dropzone";
import { toast } from "react-toastify";
import Swal from "sweetalert2"; //caja de información centra
//import shallow from 'zustand/shallow';

//*componentes-utiles
import DivLoading from "../DivLoading";

//*css
//import "./dropzone.css"; //se carga en la cita (ejemplo.tsx)
import { Col, Row } from "react-bootstrap";
import { Button } from "@reactjscomponentrepository/frontend-components/lib/components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"; //'libreria' que cita el bote de basura
import { faTrashAlt } from "@fortawesome/free-solid-svg-icons"; //icono bote de basura

import "./dropzone.css";

//*interfaces //este elemento se podría utilizar cuando se ocupe regresar al componente que tiene el dropzone con la información que ya tenia, para ello se debe llenar este elemento antes salir.
interface PropsDrop {
  archDrop?: any;
}

//*componente
export default function GeneraDropzone() {
  //*api store

  //data: mis etiquetas
  const myLabels = [
    { id: 0, desc: "Periodo a actualizar:" },
    { id: 1, desc: "Archivos incorporados:" },
    { id: 2, desc: "(esperados)" },
    { id: 3, desc: "Cargar archivos" },
    { id: 4, desc: "Remover todos los archivos" },
    { id: 5, desc: "Borrar archivo" },
    {
      id: 6,
      desc: 'Incorpore en este espacio los archivos del tema que desea actualizar, para ello siga la indicación mencionada abajo y posteriormente de clic en el botón  "Cargar archivos".',
    },
    {
      id: 7,
      desc: "Arrastre y suelte los archivos aquí, o haga clic para seleccionar archivos",
    },
    { id: 8, desc: "Resultado de la validación:" },
    { id: 9, desc: "Cerrar" },
    { id: 10, desc: "¿Desea remover <strong>TODOS</strong> los archivos?" },
    { id: 11, desc: "¿Desea remover el archivo seleccionado?" },
    {
      id: 12,
      desc: "Para continuar con el siguiente paso, el sistema validará los archivos cargados para actualizar el tema.",
    },
    {
      id: 13,
      desc: "Todos los archivos son válidos para realizar la actualización del tema.",
    },
    {
      id: 14,
      desc: 'Para continuar de clic en el botón  <strong>"Procesar archivos"</strong>',
    },
    { id: 15, desc: "" },
    { id: 16, desc: " archivo(s) cargado(s) anteriormente" },
    {
      id: 17,
      desc: " archivo(s) <strong>no</strong> es (son) válido(s) para realizar la actualización del tema. ",
    },
    {
      id: 18,
      desc: "El sistema lo(s) eliminará del espacio para cargar los archivos.",
    },
    { id: 19, desc: "¿Desea continuar con los archivos válidos?" },
    //Usted tiene [##] archivo (s) que no son válidos para actualizar el tema [cve tema], por lo que se eliminarán del espacio para subir o cargar archivos
  ];

  //*constantes y variables
  let filesIn = [] as any; //este elemento se uso para cargar archivos inválidos (puede omitirse)
  let myFileCopia = [] as any; //copia de myFile (que es donde se guarda la lista de archivos cargados por el usuario) usada para hacer recorridos y comparaciones sin afectar el arreglo myFile

  //*useState
  //const [filesTotal, setFilesTotal] = useState(0);
  const [myFiles, setMyFiles] = useState([] as any); //guarda el listado de elementos (archivos) cargados por el usuario
  const [filesInvalid, setFilesInvalid] = useState([] as any); //este elemento se uso para cargar archivos inválidos
  //const [show, setShow] = useState(false);
  const [openDivLoading, setOpenDivLoading] = useState(false);

  //*funciones:

  //--Componente Dropzone
  function MyDropzone() {
    //*useCallback  //ya traemos los archivos (acceptedFiles acumula lo del cuadro de dialogo)
    const onDrop = useCallback(
      (acceptedFiles) => {
        //let listaFilesDupli="";
        let acceptedFilesTemp: any = [];
        let filesCarg = 0; //contador para saber si tenemos archivos que ya se cargaron y en su caso mostrar el toast
        acceptedFilesTemp = [...acceptedFilesTemp, ...acceptedFiles]; //se uso para mostrar el listado que se mostraba en error con el nombre de los archivos duplicados, pero esta inhibida la rutina ya que solo se muestra el total de ellos

        if (myFiles.length != 0) {
          /* el for es decrementado para que no se piedan los indices y pueda hacer bien el borrado */
          for (let i = acceptedFilesTemp.length - 1; i >= 0; i--) {
            if (
              myFiles.findIndex(
                (mf: any) =>
                  mf.name.toLowerCase() ===
                  acceptedFilesTemp[i].name.toLowerCase()
              ) >= 0
            ) {
              filesCarg = filesCarg + 1;

              /* generaba un listado con los archivos duplicados */
              /* i===acceptedFilesTemp.length-1?  listaFilesDupli= listaFilesDupli + acceptedFilesTemp[i].name
                    : listaFilesDupli= listaFilesDupli + ", " + acceptedFilesTemp[i].name */

              /* splice borra una posición del arreglo */
              acceptedFiles.splice(
                acceptedFiles.indexOf(acceptedFilesTemp[i]),
                1
              );
            }
          }
          /* esto sucede cuando se duplica un archivo en la zona de carga  */
          if (filesCarg > 0) {
            toast.success(() => (
              <>
                <div>
                  {myLabels[8].desc}
                  <br></br>
                  <strong>{filesCarg}</strong>
                  {myLabels[16].desc}
                </div>
              </>
            ));
          }
        }

        /* acumula de acceptedFiles a myFiles */
        setMyFiles([...myFiles, ...acceptedFiles]);
      },
      [myFiles]
    );

    //*funciones

    //--constantes de funcionalidades del dropzone, abre la ventana etc.
    const { getRootProps, getInputProps } = useDropzone({ onDrop });

    //--removeFile remueve los archivos de nuestra lista (remueve de uno a uno) desde bote de basura
    const removeFile = (file: any) => () => {
      Swal.fire({
        //title: myLabels[11].desc,
        text: "",
        icon: "question",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Si",
        cancelButtonText: "No",
        // width: widthSwal,
        width: "40%",
        html: "<div>" + myLabels[11].desc + "</div>",
      }).then((result) => {
        if (result.isConfirmed) {
          const newFiles = [...myFiles]; //arreglo de paso
          newFiles.splice(newFiles.indexOf(file), 1); //se elimina el archivo
          setMyFiles(newFiles); //uso común del useState, actualiza myFiles
          console.log("newFiles *******", newFiles.length);
          if (newFiles.length == 0) {
            // lo que hacemos en caso de quedar vacío
            console.log(
              "removeFile: que haré si se eliminan todos los elementos"
            );
          }
        }
      });
    };

    //-- genera el listado donde se acumulan nuestros archivos (lo que se pinta en el dropzone)
    //cada vez que se renderiza myfiles genera esta función
    const files = myFiles.map((file: any) => (
      <li key={file.name}>
        <Row>
          <Col sm={9} className="small align-1">
            {file.name}
          </Col>
          <Col sm={3}>
            <button
              title={myLabels[5].desc}
              onClick={removeFile(file)}
              className="btn rounded-pill "
            >
              <FontAwesomeIcon
                icon={faTrashAlt}
                className="color-blue-2"
                style={{ fontSize: "20px" }}
              />
            </button>
          </Col>
        </Row>
      </li>
    ));

    //*vista: //--pintado del dropzone (adecuado a nuestro diseño)
    return (
      <div className=" dropzone dz-message">
        <section className="container backcolor-blue-7">
          <div
            {...getRootProps({ className: " align-3" })}
            style={{
              top: "2px",
              position: "relative",
              fontSize: "11px",
              textAlign: "center",
            }}
          >
            <input {...getInputProps()} />
            <span className="spanDrop">
              {/* <p className="color-blue-1 padding-top-3 a">{myLabels[6].desc}inco</p> */}
              <span className="">{myLabels[7].desc}</span>
            </span>
            <br />
            <br />
            <br />
          </div>
          <aside className="backcolor-blue-7">
            {/* nuestro listado que vamos acumulando*/}
            <ul>{files}</ul>
          </aside>
        </section>
      </div>
    );
  }

  //--botón remover archivos, limpia la lista y el dropzone
  const removeAllFiles = () => {
    Swal.fire({
      //title: myLabels[10].desc,
      text: "",
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si",
      cancelButtonText: "No",
      //width: widthSwal,
      width: "40%",
      html: "<div>" + myLabels[10].desc + "</div>",
    }).then((result) => {
      if (result.isConfirmed) {
        setMyFiles([]);
      }
    });
  };

  //--Botón Cargar archivos, se recorre el myFiles y se valida si son validos (en relación al tema), se remueve los que no pasan, los que si se envia la llamada al api con la estructura acordada y con ello se activa el paso 3
  const filesUpload = () => {
    setOpenDivLoading(true);
    filesIn = [] as any;
    myFileCopia = [] as any;
    setFilesInvalid([]);
    myFileCopia = [...myFiles];

    //* si esto sucedía se acumulaban en los archivos nom validos
    //myFiles.map((file:any,index:any) => {
    //esto era para verificar si los archivos que nos estaban pasando tenía formanto xlsx
    //let idx= topicDetail.contenido[0].archivos.findIndex((v:any)=> v.nombre_fisico + ".xlsx"  === file.name || v.nombre_fisico + ".xls"  === file.name);
    //let idx= topicDetail.contenido[0].archivos.findIndex((v:any)=> v.nombre_fisico.toLowerCase() + ".xlsx"  === file.name.toLowerCase() );
    //  if (idx<0){//no está el archivo
    //    filesIn.push({ "idx": index, "nombre_fisico": file.name });
    //}
    //})

    setOpenDivLoading(false); //inhibimos la pantalla

    if (filesIn.length > 0) {
      //se encontraron archivos no válidos
      Swal.fire({
        text: "",
        icon: "info",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Continuar",
        cancelButtonText: "Cancelar",
        //width: widthSwal,
        width: "40%",
        html:
          "<div>" +
          myLabels[8].desc +
          " <strong>" +
          filesIn.length +
          "</strong>" +
          myLabels[17].desc +
          "<br></br>" +
          myLabels[18].desc +
          "<br></br>" +
          myLabels[19].desc +
          "</div>",
      }).then((result) => {
        if (result.isConfirmed) {
          setOpenDivLoading(true);
          for (let f = filesIn.length - 1; f >= 0; f--) {
            myFileCopia.splice(filesIn[f].idx, 1);
          }

          setMyFiles(myFileCopia);
          setFilesInvalid(filesIn);
          filesUploadContinue();
        } else {
          for (let f = filesIn.length - 1; f >= 0; f--) {
            myFileCopia.splice(filesIn[f].idx, 1);
          }
          setMyFiles(myFileCopia);
          return;
        }
      });
    }
    //este else maneja que ya paso todo bien y va a bajar los archivo a la NAS
    else {
      setOpenDivLoading(true);
      setMyFiles(myFileCopia);
      setFilesInvalid(filesIn);
      setTimeout(() => {
        filesUploadContinue();
      }, 100);
    }
  };

  //-- manda los archivos a la llamda del api para ser bajados en la NAS
  const filesUploadContinue = () => {
    if (myFileCopia.length > 0) {
      const formData = new FormData(); //se declar formato (tipo formulario) que se utiliza para mandar al api cuando se suben archivos
      //formData.append("idtema", id); //otro parametro si lo ocupa el api
      formData.append("esquema", "des"); //otro parametro  si lo ocupa el api

      myFileCopia.map((e: any) => {
        //se agregan los archivos enlistados al formato de FormData
        formData.append("files", e, e.name);
      });
      //ojo este consoloe para ver los archivos tenemos que mandar la propiedad del formData con getAll
      console.log(
        "*formData es lo que manda la api para que éste generé la copiana la NAS*"
      );
      console.log("*formData:", formData.getAll("files"));

      toast.success(() => (
        <>
          <div>{myLabels[13].desc}</div>
          <div dangerouslySetInnerHTML={{ __html: myLabels[14].desc }}></div>
        </>
      ));
    }
    /* else{
              //funciones del store (stepStore.tsx)
        setStepsContentAdvance(2,20).catch(); //Contabiliza avance a 20%  (al seleccionar un tema cumple con el primer paso)
      }  */
    setOpenDivLoading(false);
  };

  //--
  //const handleClose = (filesV:any) => setShow(false);

  //*vista
  return (
    <>
      <div className="divfiles">
        <Row>
          <Col sm={12} className="align-2">
            <span>
              <Button
                type="button"
                typeStyle="secondary"
                onClick={removeAllFiles}
                className="margin-3"
                disabled={myFiles.length === 0 ? true : false}
              >
                <span>{myLabels[4].desc}</span>
              </Button>
              &nbsp;
              <Button
                typeStyle="secondary"
                onClick={filesUpload}
                className="margin-3 margin-1"
                disabled={myFiles.length === 0 ? true : false}
              >
                <span>{myLabels[3].desc}</span>
              </Button>
              &nbsp;&nbsp;&nbsp;
            </span>
          </Col>
        </Row>
        <Row className="padding-3">
          <Col sm={6}>
            <MyDropzone />
          </Col>
        </Row>
      </div>
      {/*  <Example/> */}
      {openDivLoading ? <DivLoading /> : null}
    </>
  );
}
